const RETURN_TO_KEY = 'encompass_return_to';
const DEFAULT_RETURN_TO = '/closing-board/calendar';

export const encompassAuthorizeUrl = () => {
  const clientId = process.env.REACT_APP_ENCOMPASS_CLIENT_ID;
  const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URL);
  return `https://idp.elliemae.com/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&state=&scope=lp`;
};

export const startEncompassLogin = returnTo => {
  try {
    sessionStorage.setItem(RETURN_TO_KEY, returnTo);
  } catch (error) {
    // Storage can be blocked; the callback then falls back to the closing board.
  }
  window.location.href = encompassAuthorizeUrl();
};

export const takeEncompassReturnTo = () => {
  try {
    const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    return returnTo || DEFAULT_RETURN_TO;
  } catch (error) {
    return DEFAULT_RETURN_TO;
  }
};
